const GET_RECENTS = "GET_RECENTS";
const GET_RECENTS_SUCCESS = "GET_RECENTS_SUCCESS";
const GET_RECENTS_FAIL = "GET_RECENTS_FAIL";

const initialState = {
  data: [],
  loading: false,
  hasError: false,
  messageError: "",
  page: 1,
  totalCount: 0,
};

export default function recents(state = initialState, action) {
  switch (action.type) {
    case GET_RECENTS: {
      return {
        ...state,
        loading: true,
        page: action.payload.page,
      };
    }

    case GET_RECENTS_SUCCESS: {
      let { data, totalCount, page } = action.payload.data;

      return {
        ...state,
        loading: false,
        data: state.data.concat(data),
        totalCount,
        page,
      };
    }

    case GET_RECENTS_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }
    default:
      return state;
  }
}

export function getRecents(page = 0) {
  return {
    type: GET_RECENTS,
    payload: {
      page,
      request: {
        url: `Favorite/Recents?page=${page}`,
      },
    },
  };
}
